module.exports = __webpack_public_path__ + "img/xtbb.5b1c8405.svg";